<script setup lang="ts">
import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  Position,
} from '@vue-flow/core';
import { computed } from 'vue';

interface BezierPathParams {
  sourceX: number;
  sourceY: number;
  sourcePosition?: Position;
  targetX: number;
  targetY: number;
  targetPosition?: Position;
  curvature?: number;
}

interface RoomEdgeProps {
  id: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  sourcePosition: string;
  targetPosition: string;
  data: {
    sourceFloorLevel: {
      type: string;
      level: number;
    };
    targetFloorLevel: {
      type: string;
      level: number;
    };
    [key: string]: any;
  };
}

const props = defineProps<RoomEdgeProps>();

const path = computed(() => getBezierPath(props as BezierPathParams));

const stairsDirection = computed(() => {
  const sourceType = props.data.sourceFloorLevel.type;
  const targetType = props.data.targetFloorLevel.type;

  if (sourceType === 'GROUND' && targetType === 'UPPER') {
    return 'mdi-arrow-up';
  }

  if (sourceType === 'GROUND' && targetType === 'BASEMENT') {
    return 'mdi-arrow-down';
  }

  if (sourceType === targetType) {
    if (props.data.sourceFloorLevel.level > props.data.targetFloorLevel.level) {
      return 'mdi-arrow-down';
    } else if (
      props.data.sourceFloorLevel.level < props.data.targetFloorLevel.level
    ) {
      return 'mdi-arrow-up';
    }
  }
  return undefined;
});
</script>

<template>
  <BaseEdge :id="id" :path="path[0]" />
  <EdgeLabelRenderer>
    <div
      v-if="stairsDirection"
      data-testId="stairs-label"
      :style="{
        position: 'absolute',
        transform: `translate(-50%, -50%) translate(${path[1]}px,${path[2]}px)`,
      }"
      class="dark: flex h-5 w-10 items-center justify-center rounded-sm border-2 border-primary-2 bg-light-2 dark:bg-dark-2"
    >
      <em class="mdi" :class="stairsDirection"></em>
      <em class="mdi mdi-stairs"></em>
    </div>
  </EdgeLabelRenderer>
</template>
